import { render, staticRenderFns } from "./PaginationVue.vue?vue&type=template&id=84bfcce8&lang=pug"
import script from "./PaginationVue.vue?vue&type=script&lang=js"
export * from "./PaginationVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84bfcce8')) {
      api.createRecord('84bfcce8', component.options)
    } else {
      api.reload('84bfcce8', component.options)
    }
    module.hot.accept("./PaginationVue.vue?vue&type=template&id=84bfcce8&lang=pug", function () {
      api.rerender('84bfcce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaginationVue.vue"
export default component.exports